const stats = [
  { value: "12", label: "APIC Centres" },
  { value: "340+", label: "Machines Available" },
  { value: "4,820", label: "Active Innovators" },
  { value: "18,600", label: "Prototypes Delivered" },
  { value: "260+", label: "Industry Experts" },
];

export default function Stats() {
  return (
    <section className="relative bg-gradient-to-b from-slate-50 via-indigo-50/40 to-white overflow-hidden py-2.5">
  {/* Background Blur */}
  <div className="absolute -top-32 left-0 w-80 h-80 bg-indigo-200/30 rounded-full blur-3xl"></div>
  <div className="absolute -bottom-32 right-0 w-80 h-80 bg-cyan-200/30 rounded-full blur-3xl"></div>

  <div className="max-w-7xl mx-auto px-6 relative z-10">
    {/* Heading */}
    <div className="text-center mb-14">
      <h2 className="text-4xl font-bold text-slate-900">
        APIC by the Numbers
      </h2>
      <p className="mt-3 text-slate-500 text-lg max-w-2xl mx-auto">
        Empowering innovators across Andhra Pradesh with cutting-edge
        prototyping facilities, expert guidance, and advanced machines.
      </p>
    </div>

    {/* Stats Cards */}
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-6">
      {stats.map(({ value, label }) => (
        <div
          key={label}
          className="group rounded-3xl bg-white border border-slate-200 shadow-sm hover:shadow-xl hover:-translate-y-2 transition-all duration-300 p-8 text-center"
        >
          <h3 className="text-4xl md:text-5xl font-extrabold bg-gradient-to-r from-indigo-600 to-cyan-500 bg-clip-text text-transparent">
            {value}
          </h3>

          <div className="w-12 h-1 bg-gradient-to-r from-indigo-600 to-cyan-500 rounded-full mx-auto my-4 group-hover:w-20 transition-all duration-300"></div>

          <p className="text-slate-600 font-medium leading-6">
            {label}
          </p>
        </div>
      ))}
    </div>
  </div>
</section>
  );
}